import { SvgHome } from '@itwin/itwinui-icons-react';
import ReactDOMServer from 'react-dom/server';

export const SvgHomeIcon = ReactDOMServer.renderToStaticMarkup(SvgHome({}));

export const SvgWorkExchange = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M16,8v8H0V8L2,4H5V5H2.5L1,8H4a4,4,0,0,0,8,0h3L13.5,5H11V4h3ZM7,7H5l3,3,3-3H9V3h2L8,0,5,3H7Z"
      fillRule="evenodd"
    />
  </svg>`;

export const SvgDesignTask = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M15.1 1H1c-.5 0-1 .4-1 .9v9.2c0 .5.4.9.9.9H7v2c-.9.2-1.9 1-1.2 1h4.3c.7 0-.7-.9-1.1-1v-2h6c.5 0 1-.4 1-1V2c0-.5-.4-1-.9-1zm-.1 9H1V2h14v8zM9 6.4l1.9-1.9s.1-.4-.4-1c-.6-.5-1-.4-1-.4L7.6 5 5.4 7.1l-.3 1.8 1.8-.4L9 6.4zM6.1 8.5c0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.4-.2l.1-.6.2-.2c.3 0 .5.2.7.4s.3.4.4.7l-.2.2-.6.1z"
    />
  </svg>`;

export const SvgTwoDocuments = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M10 4h4v9H4V0h6zm1-4v3h3zM3 2H2v13h10v-1H3z" />
  </svg>`;

export const SvgDesignReview2D = `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 1.23v11.078H4.923L1.231 16v-3.692H0V0h14.77L7.384 7.385 4.923 4.923l-1.23 1.23 3.692 3.693z"
      fillRule="evenodd"
    />
  </svg>`;

export const SvgDesignReview = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path
    d="M8.08552,3.191,2.79488,5.51632,8.08552,7.83681l5.29063-2.32049ZM2.40535,6.0282v6.83471L7.77,15.2224V8.3828Zm11.36034,0L8.40108,8.3828v6.8396l5.36461-2.35949Z"
  />
  <polygon points="8.443 2.276 9.601 2.276 8.086 0.778 6.57 2.276 7.728 2.276 8.443 2.276"/>
  <polygon points="1.07 13.072 0.434 12.115 0 14.191 2.099 14.619 1.463 13.662 1.07 13.072"/>
  <polygon points="14.93 13.072 15.566 12.115 16 14.191 13.901 14.619 14.537 13.662 14.93 13.072"/>
</svg>`;

export const SvgDesignValidation = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <g clipPath="url(#_clipPath_8NipMO6pNxd3CKzwud9VSQLW9DzOugQg)">
    <path
      d=" M 12.704 9.458 C 10.897 9.458 9.433 10.923 9.433 12.729 C 9.433 14.535 10.897 16 12.704 16 C 14.51 16 15.974 14.536 15.974 12.729 C 15.974 10.923 14.51 9.458 12.704 9.458 Z  M 12.152 14.365 L 10.659 12.97 L 11.232 12.439 L 12.197 13.338 L 14.172 11.503 L 14.748 12.03 L 12.152 14.365 L 12.152 14.365 Z  M 11.625 8.689 L 11.625 4.101 C 11.624 3.524 11.315 2.991 10.815 2.702 L 6.664 0.232 C 6.138 -0.077 5.487 -0.077 4.961 0.232 L 0.81 2.702 C 0.309 2.999 0.001 3.539 0 4.122 L 0 9.164 C 0.006 9.746 0.312 10.283 0.81 10.584 L 4.961 13.054 C 5.487 13.363 6.138 13.363 6.664 13.054 L 8.588 11.909 C 8.9 10.338 10.092 9.098 11.625 8.689 Z  M 5.813 2.699 C 6.3 2.699 6.695 3.094 6.695 3.581 C 6.695 4.068 6.3 4.463 5.813 4.463 C 5.325 4.463 4.93 4.068 4.93 3.581 C 4.93 3.094 5.325 2.699 5.813 2.699 Z  M 8.202 10.508 L 5.939 11.855 C 5.874 11.894 5.793 11.894 5.728 11.856 L 3.423 10.495 C 3.36 10.458 3.321 10.39 3.321 10.316 L 3.321 9.12 C 3.321 9.005 3.414 8.912 3.529 8.912 C 3.566 8.912 3.603 8.922 3.635 8.941 L 4.982 9.688 L 4.982 6.839 L 4.253 6.375 C 4.19 6.337 4.152 6.27 4.152 6.196 L 4.152 4.996 C 4.152 4.881 4.245 4.788 4.359 4.788 C 4.397 4.788 4.434 4.798 4.466 4.818 L 6.542 5.966 C 6.605 6.004 6.643 6.071 6.643 6.144 L 6.643 9.688 L 7.99 8.941 C 8.088 8.883 8.216 8.915 8.274 9.014 C 8.293 9.046 8.304 9.082 8.304 9.12 L 8.304 10.329 C 8.304 10.402 8.265 10.47 8.202 10.508 Z "
    />
  </g>
</svg>`;

export const SvgIssueResolution = `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 0h1.29v16H1zm14 8H3.582V0H15l-4.667 3.975z"
    />
  </svg>`;

export const SvgDeliverablesManagement = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M.4 8.4l9 8.8L25 4.3zM0 8.9l6.2 6.3L0 22.9z"
    />
    <path
      d="M.5 23.4l6.3-7.7 2.6 2.7 4.7-3.9L25 27.6zM14.7 13.9l11.1 13.3V4.6zM26.6 4.7L32 8.2v16.3l-5.3 3.2z"
    />
  </svg>`;

export const SvgProjectInsights = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M30.629 13.455L19.415 6.027a6.19 6.19 0 00-6.83 0L1.37 13.455a3.05 3.05 0 000 5.09l11.214 7.428a6.19 6.19 0 006.83 0l11.214-7.428a3.05 3.05 0 000-5.09zm-15.886 7.701a5.297 5.297 0 01.888-10.442.354.354 0 01.369.337v4.117a.347.347 0 00.592.243l2.92-2.9a.354.354 0 01.498-.004l.011.012a5.28 5.28 0 01-.52 7.481 5.362 5.362 0 01-4.758 1.156z"
  />
  </svg>`;
